export const RoleRouting = [
  {
    path: "/organization/role/list",
    name: "organization-role-list",
    meta: { title: "角色管理" },
    component: () =>
      import(
        /* webpackChunkName: "basic-organization-role" */ "@/views/organization/role/list/index.vue"
      ),
  },
];
